import { InitialsAvatar } from '@/components/shared/InitialsAvatar';
import { TimeshiftAvatar } from '@/components/shared/TimeshiftAvatar';
import { displayName } from '@/services/translation/name';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

interface TeamCalendarRowHeaderProps {
  employee: {
    identityId?: string | null;
    employeeId?: string | null;
    firstName?: string;
    lastName?: string | null;
    avatarUrl?: string | null;
  };
  teamCalendarAnchorDate: string;
}

export const TeamCalendarRowHeader: FC<TeamCalendarRowHeaderProps> = ({ employee, teamCalendarAnchorDate }) => {
  const navigate = useNavigate();
  const employeeName = displayName({
    firstName: employee.firstName,
    lastName: employee.lastName || undefined
  });

  return (
    <div className="flex h-full items-center gap-3 px-4 py-2">
      <TimeshiftAvatar size={35} name={employeeName} src={employee.avatarUrl} />
      <button
        type="button"
        onClick={() =>
          navigate(
            `/team-member/${employee.identityId}?from=team-calendar&teamCalendarAnchorDate=${teamCalendarAnchorDate}`
          )
        }
        className="truncate text-left text-sm font-medium text-primary-std hover:underline"
      >
        <p className="font-semibold leading-tight">{employeeName}</p>
        <p>{employee.employeeId}</p>
      </button>
    </div>
  );
};
